var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"meichu2025"}},[_c('MobileNav'),_c('Nav'),_c('div',{staticClass:"main"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('footer',[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }